import { render, staticRenderFns } from "./ParamDropdown.vue?vue&type=template&id=24a8d548&scoped=true&"
import script from "./ParamDropdown.vue?vue&type=script&lang=ts&"
export * from "./ParamDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8d548",
  null
  
)

export default component.exports